import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';

import { SharedModule } from '../shared/shared.module';

import { RequestFormProductViewComponent } from './request-form-product-view.component';

@NgModule({
  declarations: [RequestFormProductViewComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NgCakeItEasyUtilsModule,
    SharedModule,
  ],
  exports: [RequestFormProductViewComponent],
})
export class RequestFormProductViewModule {}
